type PurchaseOptionVisibilityInputs = Readonly<{
  isCatalogItem: boolean;
  isGroupGiftingFeatureEnabled: boolean;
  isInternationalRegistry: boolean;
  hasExistingGroupGift: boolean;
}>;

type PurchaseOptionVisibility = Readonly<{
  showPurchaseOptions: boolean;
  showGroupGifting: boolean;
}>;

export const getPurchaseOptionVisibility = ({
  isCatalogItem,
  isGroupGiftingFeatureEnabled,
  isInternationalRegistry,
  hasExistingGroupGift,
}: PurchaseOptionVisibilityInputs): PurchaseOptionVisibility => {
  const isOfferable = !isInternationalRegistry || hasExistingGroupGift;

  return {
    showPurchaseOptions: !isCatalogItem && isOfferable,
    showGroupGifting: isGroupGiftingFeatureEnabled && isCatalogItem && isOfferable,
  };
};
